<template>
  <div>
    <loading-box
        :loading="loading">
    </loading-box>
    <div class="container user-navegation" v-if="template === 'full'">
      <p>
        <span>Informações coletadas do Lattes {{(dataUltimaAtualizacao !== '') ? 'em ' + dataUltimaAtualizacao: '' }}</span>
      </p>
      <button
          class="btn btn-primary btn-sm"
          @click.prevent="updateLattes"
          :disabled="loading.isVisible"
          style="margin-bottom: 1em;"
      >
        Atualizar Lattes
      </button>
    </div>
    <div v-else-if="template === 'light'">
      <button
          class="btn -clear -hasIcon"
          @click.prevent="updateLattes"
          :disabled="loading.isVisible"
      >
        <icon name="list-reload" size="medium" class="-left -out"></icon>
        Atualizar Lattes
      </button>
    </div>

    <div class="container" v-if="template === 'buttom'">
      <button
          class="btn btn-primary btn-sm"
          @click.prevent="updateLattes"
          :disabled="loading.isVisible"
          style="margin-bottom: 1em;"
      >
        Atualizar Lattes
      </button>
    </div>
  </div>
</template>

<script>
import Loading from '../../core/Loading';

export default {
  name: "UserUpdateLattes",
  props: {
    dataUltimaAtualizacao: String,
    template: String,
    lattesId: String,
  },
  data(){
    return {
      loading: new Loading(),
      form: {
        lattes_id: this.lattesId,
      },
      submitted: false,
    }
  },
  methods: {
    updateLattes() {
      EventBus.$emit('loading-show');
      axios.post('/api/v2/usuario/solicitar-atualizacao-lattes', this.form)
        .then(response => {
          let message = response.data.message || 'Solicitação de atualização de Lattes enviada com sucesso!';
          let status = response.data.status || 'success';
          EventBus.$emit('loading-hide');
          EventBus.$emit('loading-updateStatus', {message, status});
        })
        .catch(error => {
          EventBus.$emit('loading-hide');
          let message = error.response.data.message || 'Erro ao enviar solicitação de atualização de Lattes!';
          let status = 'failed';
          EventBus.$emit('loading-updateStatus', {message, status});
        });
    }
  }
}
</script>

<style scoped>

</style>